export default "__VITE_ASSET__CQBxZGo6__"